export async function displayFormErrors(form) {
  const values = form.getValues();
  const { isValid, errors } = await form.validateAll(values, false);
  form.setTouched(Object.keys(form._inputs), true, false);
  if (!isValid) {
    form.props.onInvalidSubmit(null, errors, values);
  }
}

export async function validateForm(form, predicate = true) {
  if (!form.hasError() && (predicate === true || predicate())) {
    return true;
  } else {
    await displayFormErrors(form);
    return false;
  }
}

export function castEventToValue(thing) {
  if (thing && thing.target && typeof thing.target.value !== 'undefined') {
    return thing.target.value;
  }
  return thing;
}

export function castCheckedEventToValue(thing) {
  if (thing && thing.target && typeof thing.target.checked !== 'undefined') {
    return thing.target.checked;
  }
  return thing;
}
